import { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default {
    navBarMenu: {
        //Horizontal view
        '&.navbar-menu--horizontal': {
            alignItems: 'center',

            '.navbar-menu__item-divider': {
                opacity: 0.24,
                width: '1px',
                height: '16px',
                backgroundColor: (theme: Theme) => theme.componentSettings.topbar.textColor,
            },

            '.navbar-menu__root-item-holder': {
                position: 'relative',
                '&.navbar-menu__root-item-holder--active': {
                    filter: (theme: Theme) => `drop-shadow(0px 4px 7px ${alpha(theme.palette.text.primary, 0.240636)})`,
                },
            },
            '.navbar-menu__root-item': {
                borderRadius: 1,
                userSelect: 'none',
                backgroundColor: 'transparent',
                padding: '0 12px',
                lineHeight: '26px',
                color: (theme: Theme) => theme.componentSettings.topbar.textColor,
                textDecoration: 'none',
            },
            '.navbar-menu__root-item-holder.navbar-menu__root-item-holder--active .navbar-menu__root-item': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                backgroundColor: 'background.default',
                color: 'primary.main',
            },
            '.navbar-menu__root-item-holder:not(.navbar-menu__root-item-holder--active) .navbar-menu__root-item:hover':
                {
                    cursor: 'pointer',
                    transition: (theme: Theme) => theme.transitions.create(['background-color']),
                    backgroundColor: (theme: Theme) => alpha(theme.componentSettings.topbar.textColor, 0.16),
                },
            '.navbar-menu__root-item-icon': {
                width: 16,
                height: 16,
                mr: 1,
                ml: -0.5,
                fontSize: '16px',
                flexShrink: 0,
                img: {
                    maxWidth: 1,
                    maxHeight: 1,
                },
                '&.avatar-icon': {
                    borderRadius: '100%',
                    overflow: 'hidden',
                },
            },
            '.navbar-menu__root-item-label--username': {
                whiteSpace: 'nowrap',
            },
            '.navbar-menu__root-item-component-icon': {
                '.MuiIconButton-root': {
                    borderRadius: 1,
                    py: '5px',
                    color: (theme: Theme) => theme.componentSettings.topbar.textColor,
                    '&:hover': {
                        backgroundColor: (theme: Theme) => alpha(theme.componentSettings.topbar.textColor, 0.16),
                        cursor: 'pointer',
                        transition: (theme: Theme) => theme.transitions.create(['background-color']),
                        color: (theme: Theme) => theme.componentSettings.topbar.textColor,
                    },
                    '&.active-state': {
                        pointerEvents: 'none',
                        backgroundColor: 'background.default',
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        color: 'primary.main',
                    },
                },
            },
            '.navbar-menu__submenu': {
                top: '100%',
                right: 0,
                borderTopRightRadius: 0,
            },
        },

        //Vertical view
        '&.navbar-menu--vertical': {
            '.navbar-menu__item-divider': {
                opacity: 0.24,
                width: '100%',
                height: '1px',
                backgroundColor: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
            },
            '.navbar-menu__root-item-holder': {
                position: 'relative',
                '&.navbar-menu__root-item-holder--active': {
                    filter: (theme: Theme) => `drop-shadow(0px 4px 7px ${alpha(theme.palette.text.primary, 0.240636)})`,
                },
            },
            '.navbar-menu__root-item': {
                borderRadius: 1,
                userSelect: 'none',
                backgroundColor: 'transparent',
                padding: 0.5,
                lineHeight: '22px',
                textDecoration: 'none',
                color: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
            },
            '.navbar-menu__root-item-holder:not(.navbar-menu__root-item-holder--active) .navbar-menu__root-item:hover':
                {
                    cursor: 'pointer',
                    transition: (theme: Theme) => theme.transitions.create(['background-color']),
                    backgroundColor: (theme: Theme) => alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                },
            '.navbar-menu__root-item-holder.navbar-menu__root-item-holder--active .navbar-menu__root-item': {
                backgroundColor: (theme: Theme) => alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
            },
            '.navbar-menu__root-item-icon': {
                width: 24,
                height: 22,
                mr: 0.5,
                fontSize: '16px',
                flexShrink: 0,
                img: {
                    maxWidth: 1,
                    maxHeight: 1,
                },
                '&.avatar-icon': {
                    borderRadius: '100%',
                    overflow: 'hidden',
                },
            },
            '.navbar-menu__root-item-label--username': {
                whiteSpace: 'nowrap',
            },
            '.navbar-menu__submenu': {
                left: '100%',
                bottom: 0,
            },
        },
    },

    submenuItemHolder: {
        position: 'absolute',
        backgroundColor: 'background.default',
        color: 'text.primary',
        borderRadius: 1,

        '&.navbar-submenu--scroll': {
            overflow: 'auto',
            maxHeight: '340px',
        },

        '.navbar-submenu__divider': {
            height: '1px',
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        },

        '.navbar-menu__root-item-holder > & > .navbar-submenu__item-holder--hovered  > .navbar-submenu__item:not(:hover)':
            {
                backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
                color: 'primary.main',
                borderLeftColor: 'currentColor',
            },

        '.navbar-submenu__item-holder': {
            position: 'relative',
            '&.navbar-submenu__item-holder--hovered > .navbar-submenu': {
                display: 'block',
                margin: `0 0 0 -4px`,
                '.navbar-menu--horizontal &': {
                    inset: `0 auto auto 100%`,
                },
                '.navbar-menu--vertical &': {
                    inset: `auto auto 0 100%`,
                },
            },
            '&.navbar-submenu__item-holder--direction-right > .navbar-submenu': {
                margin: `0 0 0 -4px`,
                boxShadow: '-7px 0px 7px -7px rgba(34, 34, 34, 0.240636)',
                '.navbar-menu--horizontal &': {
                    inset: `0 auto auto 100%`,
                },
                '.navbar-menu--vertical &': {
                    inset: `auto auto 0 100%`,
                },
            },
            '&.navbar-submenu__item-holder--direction-left > .navbar-submenu': {
                margin: `0 -4px 0 0`,
                boxShadow: '7px 0px 7px -7px rgba(34, 34, 34, 0.240636)',
                '.navbar-menu--horizontal &': {
                    inset: `0 100% auto auto`,
                },
                '.navbar-menu--vertical &': {
                    inset: `auto 100% 0 auto`,
                },
            },
        },
        '.navbar-submenu__item': {
            padding: '5px 8px 5px 7px',
            borderLeft: '1px solid transparent',
            position: 'relative',
            flexDirection: 'row',
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': {
                backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.8),
                color: 'background.default',
                cursor: 'pointer',
                textDecoration: 'none',
            },
        },
        '.navbar-submenu__item-icon': {
            width: 16,
            height: (theme: Theme) => theme.size.lineHeight * (theme.typography.topBarMenu.fontSize as number),
            mr: 1,
        },
        '.navbar-submenu__item-label': {
            flexGrow: 1,
            wordWrap: 'break-word',
            overflow: 'hidden',
        },
        '.navbar-submenu__item-children-ico': {
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: '16px',
        },
    },
};
